/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which LAYOUT the surface renders in on this channel. Not the chrome — the DevourPlay wrapper is decided by the channel (Public is wrapped; Private and Custom Domain are standalone), so a Public surface set to HUB keeps the wrapper. Chosen per channel because one surface can present differently on each.
 * @export
 */
export const DistributionStyle = {
    PAGE: 'PAGE',
    HUB: 'HUB'
} as const;
export type DistributionStyle = typeof DistributionStyle[keyof typeof DistributionStyle];


export function instanceOfDistributionStyle(value: any): boolean {
    for (const key in DistributionStyle) {
        if (Object.prototype.hasOwnProperty.call(DistributionStyle, key)) {
            if (DistributionStyle[key as keyof typeof DistributionStyle] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DistributionStyleFromJSON(json: any): DistributionStyle {
    return DistributionStyleFromJSONTyped(json, false);
}

export function DistributionStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionStyle {
    return json as DistributionStyle;
}

export function DistributionStyleToJSON(value?: DistributionStyle | null): any {
    return value as any;
}

export function DistributionStyleToJSONTyped(value: any, ignoreDiscriminator: boolean): DistributionStyle {
    return value as DistributionStyle;
}

